// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__53Los","container":"Home_container__qRlyu","products":"Home_products__uEGCX","news":"Home_news__Gqpu5"};